<template>
	<Form ref="formValidate" :model="formValidate" :label-width="110" :label-colon="true">
		<Row>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="位置编码" :label-width="80">
				<Input v-model="formValidate.positionCode" clearable />
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="类型" :label-width="60">
				<Select v-model="formValidate.type" style="width:200px" clearable>
					<Option v-for="item in linkTypes" :value="item.value" :key="item.value">{{ item.name }}
					</Option>
				</Select>
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="状态" :label-width="60">
				<Select v-model="formValidate.status" style="width:200px" clearable>
					<Option value="1">启用</Option>
					<Option value="0">停用</Option>
				</Select>
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="标题" :label-width="80">
				<Input v-model="formValidate.title" clearable />
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="跳转链接" :label-width="80">
				<Input v-model="formValidate.linkUrl" clearable />
			</FormItem>
			</Col>
			<Col :md="12" :sm="12" :xs="24">
			<FormItem>
				<Button type="primary" @click="formSubmit" icon="md-search"style="margin: 0 8px 16px 16px;">查询</Button>
				<Button type="default" @click="formReset" style="margin: 0 8px 16px 16px;">重置</Button>
				<Button type="success" @click="exportExcel" icon="ios-cloud-download-outline" style="margin: 0 8px 16px 16px;">导出数据</Button>
			</FormItem>
			</Col>

		</Row>
	</Form>

</template>
<script>
	import { mapGetters } from 'vuex'
	import { STATISTICS_START_TIME, LINK_TYPES } from '../../config/constants'

	export default {
		name: 'QueryCondition',
		props: {
			showPageStatus: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				linkTypes: LINK_TYPES,
				formValidate: {
					positionCode: '',
					type: '',
					status: ''
				},
				dateRangeOptions: {
					disabledDate(date) {
						const startDate = new Date(STATISTICS_START_TIME).getTime()
						const now = Date.now()
						return (
							date && !(date.valueOf() >= startDate && date.valueOf() <= now)
						)
					}
				}
			}
		},
		computed: {
			...mapGetters('statistics', ['accountGroup', 'pageStatus'])
		},
		methods: {
			formSubmit() {
				this.$emit('query', this.getFormData())
			},
			exportExcel(){
				this.$emit('exportExcel', this.getFormData())
			},
			formReset() {
				this.$refs['formValidate'].resetFields()
				this.formValidate = {
					dateRange: [],
				}
				this.formSubmit()
			},
			getFormData() {

				const formData = { ...this.formValidate }
				return formData
			}
		}
	}
</script>
